import { GetterTree } from 'vuex';
import { SubscriptionStateI, IcsSubscriptionI } from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<SubscriptionStateI, RootStateI> = {
  subscriptions(state): IcsSubscriptionI[] {
    return state.subscriptions;
  },

  isLoading(state): boolean {
    return state.loading;
  },

  error(state): string | null {
    return state.error;
  },

  subscriptionsByCalendar(state) {
    return (calendarId: string | number) => state.subscriptions.filter(
      (s) => s.calendarId === calendarId,
    );
  },

  activeSubscriptions(state): IcsSubscriptionI[] {
    return state.subscriptions.filter((s) => s.status === 'active');
  },

  failedSubscriptions(state): IcsSubscriptionI[] {
    return state.subscriptions.filter((s) => s.status === 'failed');
  },

  getSubscriptionById(state) {
    return (id: string) => state.subscriptions.find((s) => s.id === id);
  },
};
